export default {
  route: '',
  errorFlag: true,
  timeoutErrorFlag: false
}
